import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "body", "button"]
  static values = {
    buttonIcon: String,
    title: String,
    body: String,
    button: String,
    classes: String,
  }

  // declare titleValue: string;
  // declare bodyValue: string;
  // declare buttonValue: string;
  // declare classesValue: string;

  // declare titleTarget: HTMLDivElement;
  // declare bodyTarget: HTMLDivElement;
  // declare buttonTarget: HTMLButtonElement;

  requestSubmit = (e) => {
    const button = e.currentTarget
    // Write into the label span when there is one, so the button's icon survives.
    const label = button.querySelector("span") || button
    const text = label.innerText
    button.disabled = true
    label.innerText = "Loading..."
    setTimeout(() => {
      button.disabled = false
      label.innerText = text
    }, 2000)
    const form = this.element.querySelector("form")
    form?.requestSubmit()
  }

  close = () => {
    const dialog = this.element //as HTMLDialogElement;
    dialog?.close()
  }

  connect() {
    const dialog = this.element //as HTMLDialogElement;
    // Write into the label span when there is one, so the button's icon survives.
    const buttonLabel = this.buttonTarget.querySelector("span")
    if (buttonLabel) {
      buttonLabel.innerText = this.buttonValue
    } else {
      this.buttonTarget.innerHTML = this.buttonValue
    }
    // A custom icon (an `icon(...)` helper's markup) replaces the default icon's artwork,
    // keeping the default's sizing and color classes.
    const buttonIcon = this.buttonTarget.querySelector("svg")
    if (buttonIcon && this.buttonIconValue.length > 0) {
      const template = document.createElement("template")
      template.innerHTML = this.buttonIconValue
      const customIcon = template.content.querySelector("svg")
      if (customIcon) {
        buttonIcon.innerHTML = customIcon.innerHTML
      }
    }
    if (this.classesValue.length > 0) {
      this.buttonTarget.classList = ""
      this.buttonTarget.classList.add(...this.classesValue.split(" "))
      this.buttonTarget.classList.remove("rounded-md", "px-2")
      this.buttonTarget.classList.add("rounded-full", "px-4", "py-2", "font-semibold")
    }
    if (this.titleValue === "Are you sure?" && this.bodyValue === "Are you sure?") {
      this.titleValue = "Confirm"
    }
    this.titleTarget.innerText = this.titleValue
    this.bodyTarget.innerText = this.bodyValue

    document.body.classList.add("overflow-hidden")
    dialog.showModal()
    dialog.addEventListener("close", () => {
      document.body.classList.remove("overflow-hidden")
      dialog.remove()
    })

    setTimeout(() => {
      dialog.classList.remove("backdrop:opacity-0", "opacity-0")
      dialog.classList.add("backdrop:opacity-100", "opacity-100")
    }, 5)

    dialog.addEventListener("click", function (event) {
      const rect = dialog.getBoundingClientRect()
      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width
      if (!isInDialog) {
        // dialog.close();
      }
    })
  }
}
